const state = {
    tabActive: 0,
    filter:{
        year: new Date().getFullYear(),
        month: 0,
        status: "10"
    }
    
}


const actions = {
    saveTabState ({commit}, payload) {
        commit('TAB_STATE', payload);
    },
    saveSearchFilter ({commit}, payload) {
        const { filter } = payload;
        commit('SEARCH_FILTER', filter);
    }
}

const mutations = {
    TAB_STATE: (state, response) => {
        state.tabActive = response;
    },
    SEARCH_FILTER: (state, response) => {
        const {filter} = response
        state.filter = filter;
    }
}


const getters = {
    tabState: state => {
        return state.tabActive;
    },
    filterState: state => {
        return state.filter
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};